export const VALID_HANDLES = [
  'top',
  'bottom',
  'left',
  'right',
  'top left',
  'top right',
  'bottom left',
  'bottom right',
  'left top',
  'left bottom',
  'right top',
  'right bottom',
  'auto',
];
